export default __webpack_public_path__ + "static/media/cgmp-Products-1.d67bacea.jpg";